var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M3 11h8V3H3m0 18h8v-8H3m10 8h8v-8h-8m0-10v8h8V3"}})])
}
var staticRenderFns = []

export default { render: render }